import React, { Fragment } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Button,
  Popconfirm,
  Dropdown,
  List,
  Input,
  Tag,
  Icon,
  Menu,
  Drawer,
  message
} from "antd";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import { push } from "connected-react-router";
import InfiniteScroll from "react-infinite-scroller";
import { API } from "aws-amplify";
import Mapping from "components/order-mapping";
import FBQOrderItem from "components/fqb-order";
import EtsyOrderItem from "components/etsy-order-item";
import Loading from "components/loading";
import { STATUS } from "config";
import * as Styled from "./styled";

const HELP_TEXT = {
  new:
    "New orders received from your store will show here, except digital orders and orders already marked shipped",
  pending:
    "Orders that have just been placed show up here briefly while we build the order, then they are moved to the Uploaded tab. This tab will normally be empty.",
  uploaded:
    "Orders that have been uploaded to our system and are waiting to be processed.",
  processing:
    "Orders that are being processed and will be printed and shipped soon.",
  shipped:
    "Orders that have been shipped via the FBQ system. If you ship an order outside our system it will not show in any of the tabs."
};

class Orders extends React.Component {
  state = {
    currentFilter: "new",
    loading: false,
    hasMore: true,
    isSearch: false,
    saving: null,
    page: 1,
    orders: [],
    selectedOrder: null
  };

  componentWillMount() {
    if (!this.props.currentStoreId) {
      this.props.dispatch(push("/settings/stores"));
    }
  }

  hasOneMapping = order => {
    return !!order.transactions.find(
      t => t.mapping && !(t.mapping.customized || t.mapping.ignore)
    );
  };

  hasUnmappedItem = order => {
    return !!order.transactions.find(
      t => !t.mapping || t.mapping.customized || t.mapping.ignore
    );
  };

  fetchMore = page => {
    let { orders, currentFilter, next } = this.state;
    this.setState({
      loading: true
    });

    API.get(
      "api",
      `etsy/stores/${
        this.props.currentStoreId
      }/orders?page=${page}&status=${currentFilter}&next=${next ? next : ""}`
    )
      .then(resp => {
        if (currentFilter !== this.state.currentFilter) return;
        orders = orders.concat(resp.results);
        const update = {
          orders,
          next: resp.next,
          loading: false,
          hasMore: !!resp.page || !!resp.next,
          page: resp.page
        };
        // this is etsy orders and no more items exists
        if (next && !resp.next) {
          update.hasMore = false;
          update.next = null;
        } else if (currentFilter !== "new" && !next && !resp.next) {
          update.hasMore = false;
        }
        this.setState(update);
      })
      .catch(e => {
        this.setState({ loading: false });
        message.error(e.response.data.message);
      });
  };

  handleInfiniteOnLoad = page => {
    console.log('load more')
    this.fetchMore(this.state.page);
  };

  onFulfilment = (order, mapping) => {
    this.setState({
      saving: order.receipt_id
    });

    const hide = message.loading("Placing order...", 0);

    return API.post(
      "api",
      `etsy/stores/${this.props.currentStoreId}/orders/${
        order.receipt_id
      }/fulfill`,
      {
        body: mapping
      }
    ).then(
      resp => {
        hide();
        message.success("Order sent for fulfillment");
        this.setState({
          saving: null,
          orders: this.state.orders.map(o => {
            if (order === o) {
              order.order = resp;
            }
            return o;
          })
        });
      },
      err => {
        hide();
        message.error(err.response.data.message);
        this.setState({
          saving: null
        });
        throw err.response.data.message;
      }
    );
  };

  handleMenuClick = item => {
    switch (item.key) {
      case "mapping":
        return this.onCreateMapping(item.item.props.order);
    }
  };

  onCreateMapping = item => {
    this.setState({
      selectedOrder: item
    });
  };

  onClose = () => {
    this.setState({
      selectedOrder: null
    });
  };

  onSaveMapping = async values => {
    return this.onFulfilment(this.state.selectedOrder, values).then(() => {
      this.onClose();
      values.lineItems.forEach(item => {
        if (item.saveMapping) {
          let request = null;
          if (item.mappingId) {
            // attach existing mapping
            request = API.post(
              "api",
              `mappings/${item.mappingId}/products/${item.productId}`,
              { body: item }
            );
          } else {
            // create new
            request = API.post("api", "mappings", { body: item });
          }
          request
            .then(mapping => {
              const { orders } = this.state;
              orders.forEach(order => {
                order.transactions.forEach(tnx => {
                  if (item.productId.includes(tnx.listing_id)) {
                    tnx.mapping = mapping;
                  }
                });
              });
              this.setState({ orders });
            })
            .catch(err => {
              console.error(err.response);
              message.error("There was an error in saving the mapping.");
            });
        }
      });
    });
  };

  onStatusUpdate = (order, status) => {
    API.put("api", `orders/${order.id}`, {
      body: { status }
    }).then(
      () => {
        message.success("Order updated");
        this.setState({
          orders: this.state.orders.filter(o => o !== order)
        });
      },
      e => {
        message.error(e.message);
      }
    );
  };

  onCancelOrder = order => {
    API.del("api", `orders/${order.id}`).then(
      () => {
        message.success("Order updated");
        this.setState({
          orders: this.state.orders.filter(o => o !== order)
        });
      },
      e => {
        message.error(e.message);
      }
    );
  };

  onFilterSelect = ({ key }) => {
    if (key === this.state.currentFilter) return;

    this.setState({
      currentFilter: key,
      hasMore: true,
      loading: false,
      next: null,
      orders: [],
      page: 1
    });
  };

  onSearch = query => {
    if (!query) {
      return this.setState({
        isSearch: false,
        hasMore: true,
        loading: false,
        orders: []
      });
    }

    this.setState({
      loading: true,
      orders: [],
      page: 1,
      isSearch: true
    });

    API.get(
      "api",
      `etsy/stores/${this.props.currentStoreId}/orders/search?query=${query}`
    )
      .then(resp => {
        this.setState({
          loading: false,
          orders: resp.results,
          page: 1
        });
      })
      .catch(e => {
        message.error(e.message);
      });
  };

  onQueryChange = e => {
    this.setState(
      {
        query: e.target.value
      },
      () => {
        if (!this.state.query) {
          this.onSearch();
        }
      }
    );
  };

  renderActions = row => {
    if (
      !row.canfulfil ||
      (row.transactions.length === 1 && !row.transactions[0].canfulfil)
    ) {
      return (
        <div>
          <em>
            { row.reason || 'Canceled orders, gift wrap & personalized items can\'t be fulfilled' }
          </em>
        </div>
      );
    } else if (row.order) {
      return <Tag color="green">{STATUS[row.order.status]}</Tag>;
    }
    const { defaultShippingOption } = this.props.store;
    const forceCustomization = !defaultShippingOption || (row.total_shipping_cost.amount / 100 > 40);
    row.forceCustomization = forceCustomization;

    const menu = (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key="mapping" order={row}>
          <Icon type="setting" />
          Customize this Order
        </Menu.Item>
      </Menu>
    );

    if (!this.hasOneMapping(row) || forceCustomization) {
      return (
        <Button
          type="primary"
          icon="setting"
          onClick={() => this.onCreateMapping(row)}
        >
          Customize & Fulfill
        </Button>
      );
    }
    const msg = this.hasUnmappedItem(row)
      ? "Confirm? You have unmapped products in this order. We'll place partial order"
      : "Confirm? this will send the order to our lab for fulfillment.";
    return (
      <Popconfirm title={msg} onConfirm={() => this.onFulfilment(row)}>
        <Dropdown.Button
          disabled={this.state.saving === row.receipt_id}
          type="primary"
          overlay={menu}
          trigger={["click"]}
        >
          Fulfill
        </Dropdown.Button>
      </Popconfirm>
    );
  };

  renderItem = order => {
    return (
      <List.Item>
        <Styled.OrderItem>
          {order.transactions ? (
            <EtsyOrderItem
              storeId={this.props.currentStoreId}
              order={order} actions={this.renderActions(order)} />
          ) : (
            <FBQOrderItem
              showStatus={this.state.isSearch}
              order={order}
              onStatusUpdate={this.onStatusUpdate}
              onCancelOrder={this.onCancelOrder}
            />
          )}
        </Styled.OrderItem>
      </List.Item>
    );
  };

  renderOrderMapping = order => {
    return (
      <Drawer
        visible={!!order}
        maskClosable={false}
        title="Order mapping"
        width={600}
        onClose={this.onClose}
        style={{
          overflow: "auto",
          height: "calc(100% - 108px)",
          paddingBottom: "108px"
        }}
      >
        {order ? (
          <Mapping
            onSave={this.onSaveMapping}
            order={order}
            onClose={this.onClose}
          />
        ) : null}
      </Drawer>
    );
  };

  render() {
    const { orders, loading, hasMore, currentFilter, isSearch } = this.state;
    const { store } = this.props;

    if (!store) return null;

    const list = (
      <List
        loading={isSearch && loading}
        itemLayout="vertical"
        dataSource={orders}
        renderItem={this.renderItem}
      >
        {loading && hasMore && !isSearch && <Loading size="small" />}
      </List>
    );

    return (
      <Styled.Container>
        <Helmet title={`${currentFilter} orders`}/>
        <Row type="flex" align="center">
          <Col span={12}>
            <h1>Etsy Orders</h1>
          </Col>
        </Row>
        {isSearch ? (
          list
        ) : (
          <Fragment>
            <Menu
              onClick={this.onFilterSelect}
              selectedKeys={[this.state.currentFilter]}
              mode="horizontal"
            >
              <Menu.Item key="new">New</Menu.Item>
              <Menu.Item key="pending">Order Placed</Menu.Item>
              <Menu.Item key="uploaded">Uploaded</Menu.Item>
              {/*<Menu.Item key="processing">In Process</Menu.Item>*/}
              <Menu.Item key="shipped">Shipped</Menu.Item>
            </Menu>
            <div key={currentFilter}>
              <p className="text-center">
                <span>{HELP_TEXT[currentFilter]}</span>{" "}
                {currentFilter === "new" && store.hideUnmappedOrders && (
                  <div>
                    <strong>Showing orders with mappings only.</strong>{" "}
                    <Link to={`/settings/stores/${store.storeId}/settings`}>Change</Link>
                  </div>
                )}
              </p>
              <InfiniteScroll
                initialLoad={true}
                pageStart={0}
                loadMore={this.handleInfiniteOnLoad}
                hasMore={!loading && hasMore}
                useWindow={true}
              >
                {list}
              </InfiniteScroll>
            </div>
          </Fragment>
        )}
        {this.renderOrderMapping(this.state.selectedOrder)}
      </Styled.Container>
    );
  }
}

export default connect(state => ({
  ...state.session,
  store: state.session.stores.find(
    s => s.storeId === state.session.currentStoreId
  )
}))(Orders);
